export const INIT_REGISTRATION = 'INIT_REGISTRATION';
export const ADD_STUDENT = 'ADD_STUDENT';
export const ADD_STUDENT_COUNT = 'ADD_STUDENT_COUNT';
export const ADD_CURRENT_COUNT = 'ADD_CURRENT_COUNT';
export const CLEAR = 'CLEAR';
export const ADD_CODE = 'ADD_CODE';
export const PAY_DETAILS = 'PAY_DETAILS';